// ============================================================================
// Shared Constants for Wizard Components
// ============================================================================

/**
 * Color palette for different job boundaries on the map
 */
export const BOUNDARY_COLORS = [
	"#FF6B6B", // Red
	"#4ECDC4", // Teal
	"#45B7D1", // Blue
	"#96CEB4", // Green
	"#FFEAA7", // Yellow
	"#DDA0DD", // Plum
	"#98D8C8", // Mint
	"#F7DC6F", // Gold
];

/**
 * Color for nearby jobs (grayed out)
 */
export const NEARBY_JOB_COLOR = "#9E9E9E";

/**
 * Color for highlight/intersection areas
 */
export const HIGHLIGHT_COLOR = "#FF0000";

/**
 * Stroke color for highlighted intersections
 */
export const HIGHLIGHT_STROKE_COLOR = "#B71C1C";

/**
 * Color for unmatched point features
 */
export const UNMATCHED_POINT_COLOR = "#FF6B6B";

/**
 * Color for unmatched zone features
 */
export const UNMATCHED_ZONE_COLOR = "#4ECDC4";

/**
 * Default map container height
 */
export const DEFAULT_MAP_HEIGHT = "300px";

/**
 * Default map center (Illinois)
 */
export const DEFAULT_CENTER = { lat: 40.0, lng: -89.0 };
